module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"recommended":"Populært","inProgress":"Se ferdig"},"en":{"recommended":"Popular","inProgress":"In progress"}}')
  delete Component.options._Ctor
}
